import { recentZones } from "@/mocks/guaData";

export default function RecentZones() {
  return (
    <section id="recent-point" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="mb-6 flex items-end justify-between gap-4">
          <div>
            <p className="mb-1.5 text-xs font-bold uppercase tracking-widest text-accent-700">Zones · 分区瓜点</p>
            <h2 className="font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
              最近瓜点，分区域逛
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {recentZones.map((zone) => (
            <div
              key={zone.name}
              className="flex flex-col rounded-lg border border-background-200/70 bg-background-100/50 p-5"
            >
              <div className="mb-4 flex items-center gap-2.5">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-50 text-lg text-primary-600">
                  <i className={zone.icon} />
                </span>
                <h3 className="font-heading text-base font-bold text-foreground-950">{zone.name}</h3>
              </div>
              <ul className="flex flex-1 flex-col gap-px">
                {zone.items.map((item) => (
                  <li key={item.title}>
                    <a
                      href="#live-feed"
                      className="group -mx-2 block cursor-pointer rounded-md px-2 py-3 transition hover:bg-background-50"
                    >
                      <p className="text-sm font-medium leading-snug text-foreground-900 group-hover:text-primary-700">
                        {item.title}
                      </p>
                      <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-500">{item.brief}</p>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}